import api from '../../utils/api';

export interface VendorPolicyQueryVendorDetails {
  vendorId: string;
  generatedId: string;
  email: string;
  phoneNumber: string;
  vendorRole: number;
  vendorRoleName: string;
  status: string;
  isActive: boolean;
}

export interface VendorPolicyQueryRow {
  queryId: string;
  vendorId: string;
  vendorType: number;
  vendorTypeName: string;
  comment: string;
  status: 'OPEN' | 'REVIEWED' | 'CLOSED';
  reviewedAt: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  vendorName: string;
  vendorDetails: VendorPolicyQueryVendorDetails | null;
}

interface VendorPolicyQueriesResponse {
  success: boolean;
  data: VendorPolicyQueryRow[];
  pagination: {
    limit: number;
    offset: number;
  };
}

export async function fetchVendorPolicyQueries(params?: {
  status?: 'OPEN' | 'REVIEWED' | 'CLOSED';
  isActive?: boolean;
  limit?: number;
  offset?: number;
}): Promise<VendorPolicyQueriesResponse> {
  const response = await api.get<VendorPolicyQueriesResponse>('/master-admin/vendor-policy-queries', {
    params,
  });
  return response.data;
}

export async function closeVendorPolicyQuery(
  queryId: string,
  payload?: { reviewNote?: string }
): Promise<{ success: boolean; message: string }> {
  const response = await api.patch(`/master-admin/vendor-policy-queries/${encodeURIComponent(queryId)}/close`, payload || {});
  return response.data;
}

